/**
 * Dearlove — Cart drawer : +ADD upsells.
 * Délégation sur document : les boutons vivent dans .drawer__inner,
 * re-rendu à chaque update (section rendering API), les listeners directs
 * seraient perdus.
 */
(function () {
  if (window.__dlCartInit) return;
  window.__dlCartInit = true;

  document.addEventListener('click', function (evt) {
    // Mesure (11.10.2026) : l'attribut de panier dl_second (heure du clic)
    // part dans les customAttributes de la commande.
    const markSecond = () =>
      fetch(`${routes.cart_update_url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { dl_second: new Date().toISOString() } }),
        keepalive: true,
      }).catch(() => {});
    if (evt.target.closest('a.dl-second__btn')) {
      markSecond();
      return;
    }
    // Menu couleur de la 2e piece : ouvrir / choisir / fermer au clic dehors.
    const dd = evt.target.closest('.dl-dd');
    document.querySelectorAll('#CartDrawer .dl-ddl:not([hidden])').forEach((ul) => {
      if (!ul.contains(evt.target) && ul.parentElement.querySelector('.dl-dd') !== dd) {
        ul.hidden = true;
        ul.parentElement.querySelector('.dl-dd').setAttribute('aria-expanded', 'false');
      }
    });
    if (dd) {
      const ul = dd.parentElement.querySelector('.dl-ddl');
      ul.hidden = !ul.hidden;
      dd.setAttribute('aria-expanded', String(!ul.hidden));
      return;
    }
    const opt = evt.target.closest('.dl-ddl li');
    if (opt) {
      const col = opt.closest('.dl-second__col');
      col.querySelectorAll('.dl-ddl li').forEach((li) => li.setAttribute('aria-selected', String(li === opt)));
      col.querySelector('.dl-dd .dl-dot').style.background = opt.dataset.hex;
      col.querySelector('.dl-dd__txt').textContent = opt.textContent;
      col.querySelector('[data-dl-second]').dataset.pick = opt.dataset.variantId;
      const img = col.closest('.dl-second').querySelector('.dl-second__img');
      if (img) {
        img.removeAttribute('srcset');
        img.src = opt.dataset.img;
        img.parentElement.classList.toggle('dl-thumb--zoom', opt.dataset.zoom === 'zoom');
      }
      opt.parentElement.hidden = true;
      col.querySelector('.dl-dd').setAttribute('aria-expanded', 'false');
      return;
    }
    const second = evt.target.closest('[data-dl-second]');
    if (second && second.dataset.pick && second.dataset.pick !== second.dataset.variantId) {
      // Autre couleur : nouvelle ligne, la remise compte les pieces, pas les lignes.
      evt.preventDefault();
      markSecond().finally(() => addVariant(second, parseInt(second.dataset.pick, 10)));
      return;
    }
    if (second) {
      // 2e piece : on passe la ligne a 2 par le chemin natif de Dawn (meme
      // effet que le bouton +), la remise et le tiroir se recalculent seuls.
      evt.preventDefault();
      const items = document.querySelector('cart-drawer-items');
      if (!items) return;
      second.setAttribute('aria-disabled', 'true');
      // Dawn compare la reponse au champ quantite : sans ca il affiche
      // « You can only add 2 of this item ».
      const qty = document.getElementById('Drawer-quantity-' + second.dataset.line);
      if (qty) qty.value = 2;
      markSecond().finally(() =>
        items.updateQuantity(second.dataset.line, 2, evt, null, second.dataset.variantId)
      );
      return;
    }
    const btn = evt.target.closest('[data-dl-upsell-add]');
    if (!btn) return;
    evt.preventDefault();
    addVariant(btn, parseInt(btn.dataset.variantId, 10));
  });

  function addVariant(btn, variantId) {
    if (!variantId) return;

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const body = { items: [{ id: variantId, quantity: 1 }] };
    if (cart) {
      body.sections = cart.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
    }

    btn.setAttribute('aria-disabled', 'true');

    fetch(`${routes.cart_add_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error('[dl-cart]', response.description || response.message);
          return;
        }
        if (cart) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
            cartData: response,
          });
          cart.renderContents(response);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        }
      })
      .catch((e) => console.error('[dl-cart]', e))
      .finally(() => btn.removeAttribute('aria-disabled'));
  }
})();
